// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import App from './App';
import router from './router';
import i18n from './i18n';
import 'babel-polyfill';
import './assets/css/global.css';

/* 全局注册 */
Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'api' : 'https://his-jp-dev.dragonpass.com.cn';
axios.defaults.headers.post['Content-Type'] = 'application/json';

//请求拦截器
axios.interceptors.request.use(
	(config) => {
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);

//响应拦截器
axios.interceptors.response.use(
	(response) => {
		// console.log(response.data.state);
		if (response.data.state === '99') {
			axios
				.post(
					'/api/auxiliary/getToken',
					{},
					{
						headers: {
							language: i18n.locale,
							flag: localStorage.getItem('flag')
						}
					}
				)
				.then((res) => {
					localStorage.setItem('pass', res.data.data);
					window.location.reload();
				})
				.catch((err) => {
					console.log(err);
				});
		}
		return response;
	},
	(err) => {
		return Promise.reject(err);
	}
);

const store = new Vuex.Store({
	state: {
		count: 1,
		price: 0,
		totalPrice: 0,
		currency: 'JPY',
		currencyActive: 1,
		language: 'ja',
		languageActive: 1,
		languageIcon: require('./assets/images/icon-japan@2x.png')
	},
	mutations: {
		resetCount: (state) => {
			state.count = 1;
		},
		resetTotalPrice(state, payload) {
			state.totalPrice = payload;
		},
		increment: (state) => {
			if (state.count >= 9) return;
			state.count++;
			state.totalPrice = state.price * state.count;
		},
		decrement: (state) => {
			if (state.count <= 1) return;
			state.count--;
			state.totalPrice = state.price * state.count;
		},
		setPrice(state, payload) {
			state.price = payload;
		},
		setCurrency(state, payload) {
			state.currency = payload;
		},
		setCurrencyIdx(state, payload) {
			state.currencyActive = payload;
		},
		setLanguage(state, payload) {
			state.language = payload;
		},
		setLanguageIdx(state, payload) {
			state.languageActive = payload;
		},
		setLanguageIcon(state, payload) {
			state.languageIcon = payload;
		}
	}
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	i18n,
	components: { App },
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js